import { Component, NgZone, OnInit } from '@angular/core';
import { NavController, NavParams, Platform, ModalController } from '@ionic/angular';
import { CourseInfo } from '../../../../data/club-course';
import { PopoverController, } from '@ionic/angular';
/**
 * Created by ashok on 22/12/16.
 */

@Component({
  selector: 'course-box',
  templateUrl: 'course-box.page.html',
  styleUrls: ['course-box.page.scss'],
})
export class CourseBox implements OnInit {
  courses: Array<any>; //Array<CourseInfo>;
  fromStarterList: boolean = false;
  excludeAll: boolean = false;
  isModalOpen:boolean = false;

  constructor(private nav: NavController,
    private zone: NgZone,
    private modalCtl: ModalController,
    private navParams: NavParams,
    private platform: Platform,
    private popoverCtl: PopoverController
  ) {

    this.fromStarterList = this.navParams.get("fromStarterList");
    this.excludeAll = this.navParams.get("excludeAll");
    this.isModalOpen = this.navParams.get("isFromModal");


  }
  ngOnInit() {
    this.zone.run(() => {
      this.courses = [];
      if (this.fromStarterList) {

        this.courses[0] = {
          courseId: 0,
          courseName: 'All Courses',
          coursePar: 0,
          photoUrl: '',
          teeBoxes: [],
          holes: []
        }
      }

      this.courses.push(...this.navParams.get("courses"));
      this.courses = this.courses.sort((a, b) => {
        if (a.displayOrder < b.displayOrder) {
          //   if(a.courseName < b.courseName) return -1
          //   else if(a.courseName > b.courseName) return 1
          //   else return -1
          return -1
        }
        else if (a.displayOrder > b.displayOrder) {
          //   if(a.courseName < b.courseName) return -1
          //   else if(a.courseName > b.courseName) return 1
          //   else return 1
          return 1
        }
        else return 0
        //  {
        //   if(a.courseName < b.courseName) return -1
        //   else if(a.courseName > b.courseName) return 1
        //   else return 0
        // }
      });

   
   
      if (this.excludeAll) this.courses.shift();

    });
  }
  close() {
    if(this.isModalOpen){
      this.modalCtl.dismiss();
    }
    else{
      this.popoverCtl.dismiss();
    }
  }

  selectCourse(course: any) {    
      if(this.isModalOpen){
        this.modalCtl.dismiss(course);
      }
      else{
        this.popoverCtl.dismiss(course);
      }
  }
}
